module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "page-header",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.set_payment_object.payment_detail_name))])]), _vm._v(" "), (_vm.show_done) ? _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.payment_message))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "https://cityneeds.ng/pricing"
    }
  }, [_vm._v("Go Back")])]) : _c('div', {
    staticClass: "container"
  }, [(_vm.component_view.paymentDetails) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.payment_details_data).length !== 0)) ? _c('div', [(_vm.payment_details_data.cninsurance_form_policy_amount && (_vm.payment_details_data.cninsurance_form_policy_amount > 0)) ? _c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('h4', [_vm._v("Payment Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h6', [_c('b', [_vm._v("Name")]), _c('br'), _c('br'), _vm._v("\r\n                                                    " + _vm._s(_vm.payment_details_data.customerName) + "\r\n                                                ")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 wn-h-list"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "line-height": "1.8"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), (_vm.payment_details_data.cninsurance_form_policy_amount_with_discount > 0) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('del', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount))])]), _vm._v(" \r\n                                                            "), _c('span', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount_with_discount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [(_vm.payment_details_data.cninsurance_form_policy_discount_type == 'C') ? _c('span', [_vm._v("(₦" + _vm._s(_vm.payment_details_data.cninsurance_form_policy_discount) + " discount)")]) : _vm._e(), _vm._v(" "), (_vm.payment_details_data.cninsurance_form_policy_discount_type == 'P') ? _c('span', [_vm._v("(" + _vm._s(_vm.payment_details_data.cninsurance_form_policy_discount) + " % off)")]) : _vm._e()])]) : _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_amount))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_commission))])]), _vm._v(" "), (Number(_vm.payment_details_data.cninsurance_form_policy_stamp_duty) > 0) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦")]), _vm._v(_vm._s(_vm.payment_details_data.cninsurance_form_policy_stamp_duty))])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b', [_vm._v("₦ ")]), _vm._v(_vm._s(_vm.payment_details_data.total_amount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentModeModal(_vm.payment_details_data)
      }
    }
  }, [_vm._v("Proceed")])])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Could not get payment details")])]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Could not get payment details")])]) : _c('div', [_c('div', {
    staticClass: "cx-loading-sm"
  })]), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._m(5)])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('cnpayment-modal', {
    attrs: {
      "payment_data": _vm.set_payment_data,
      "payment_object": _vm.set_payment_object
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("InsureMoto Policy Cost:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("InsureMoto Processing Fee: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Above Threshold Limit Charge (ATLC):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Total Amount: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [_c('p', [_c('b', [_vm._v("WHY YOU HAVE TO SUBSCRIBE BEFORE YOU CAN CONTACT CNpros:")])]), _vm._v(" "), _c('p', [_vm._v("Finding diligent workers is HARD. Ensuring that workers keep transactions within the loop is EVEN HARDER. "), _c('br'), _vm._v("\r\n                             Subscription fees guarantees that insurance is in place, and keeps conflict mediation mechanism active.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dd3dfc2"}!./src/components/CNPayments/template.html
// module id = 295
// module chunks = 0